import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';
import { ScenographyNoRecyclableForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/ScenographyNoRecyclableForm';
import { ScenographyRecyclableForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/ScenographyRecyclableForm';
import { QuizFormSeparator } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSeparator';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { useExternalSubmitAnswer } from '@/ui/pages/external/hooks/useExternalSubmitAnswer';
import { GenericExternalPageVenue } from '@/ui/pages/external/venue/components/GenericExternalPageVenue';

export function SiteScenography() {
  return (
    <GenericExternalPageVenue>
      <Form />
    </GenericExternalPageVenue>
  );
}

export function Form({ readOnly = false }: { readOnly?: boolean }) {
  const { onDelete, onSubmit, onEdit } = useExternalSubmitAnswer();

  const sector = 'SITE';

  const panelOpen = !readOnly;
  return (
    <ImpactQuestionContext.Provider
      value={{ panelOpen: panelOpen, hideCompleted: false }}
    >
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.SCENOGRAPHY}`)}
      />
      <ScenographyNoRecyclableForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <ScenographyRecyclableForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
    </ImpactQuestionContext.Provider>
  );
}
